export const RU_STORE_LINK = 'https://www.rustore.ru/catalog/app/ru.showroom';

export const APP_STORE_LINK =
  'https://apps.apple.com/ru/app/%D0%BA%D0%B0%D0%B1%D0%B8%D0%BD%D0%B5%D1%82-%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D1%8F-%D1%80%D1%84/id1466655789';

export const APP_GALLERY_LINK = 'https://appgallery.huawei.com/app/C104588017';

export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=ru.showroom';
